import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import get from 'lodash/get';
import classNames from 'classnames';

import uaDetector from 'rebook/apps/utils/uaDetector';
import YouTubePlayer from 'rebook/apps/base/components/YouTubePlayer';
import * as DashboardBlockListActions from 'rebook/apps/dashboard/actions/dashboardBlockListActions';
import {
  DASHBOARD_BLOCK_SET_DATA,
} from 'rebook/apps/dashboard/constants';

import styles from './style.scss';


class DashboardVideoBlock extends React.Component {
  constructor(props) {
    super(props);
    const { block } = props;
    const blockId = `${block.id}-${block.type}`;
    const userAgent = navigator && navigator.userAgent ? navigator.userAgent : null;
    const isMobile = uaDetector.isMobile(userAgent);
    this.state = {
      block,
      blockId,
      isMobile,
    };
  }

  componentDidCatch(error, errorInfo) {
    Raven.captureException(error, { extra: errorInfo });
  }

  componentDidMount() {
    this.fetchVideoDetail();
  }

  fetchVideoDetail() {
    const { blockId } = this.state;
    const { dashboardBlockList } = this.props;

    if (dashboardBlockList[blockId]) {
      return null;
    }

    const url = this.state.block.resource_uri;

    this.props.DashboardBlockListActions.fetchDashboardBlock(url)
      .then(
        ({ data, dispatch }) => {
          dispatch({
            type: DASHBOARD_BLOCK_SET_DATA,
            payload: {
              [blockId]: {
                video: data,
              },
            },
          });
        }
      )
      .catch(
        ({ data, resp }) => {
          Raven.captureMessage('failed to fetch dashboard banner due to server error', {
            level: 'error',
            extra: {
              status: resp.status,
              response: data,
            },
          });
        }
      );
  }

  getVideoId(url = '') {
    if (!url) {
      return url;
    }
    const { url: videoUrl, query } = queryString.parseUrl(url);
    const { v: queryParam } = query;

    if (!queryParam && videoUrl) {
      let parser = document.createElement('a');
      parser.href = url;
      return parser.pathname.slice(1);
    }
    else {
      return queryParam;
    }
  }

  render() {
    const { blockId, isMobile } = this.state;
    const { dashboardBlockList } = this.props;
    const url = get(dashboardBlockList[blockId], 'video.link', '');
    const videoId = this.getVideoId(url);
    const name = get(dashboardBlockList[blockId], 'video.name', '');
    const key = `youtube-player-${videoId}-${blockId}`;

    return (
      videoId
        ? (
          <div className={styles.videoContainer}>
            <div className={classNames(styles.youtubeContainer, isMobile && 'isMobile')}>
              <YouTubePlayer isMobile={isMobile} videoId={videoId} blockId={blockId} name={name} key={key} />
            </div>
            <div className={styles.videoTitle}>
              {name}
            </div>
          </div>
        )
        : null
    );
  };
};

const mapStateToProps = (state) => {
  return {
    dashboardBlockList: state.dashboardBlockList,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    DashboardBlockListActions: bindActionCreators(DashboardBlockListActions, dispatch),
  };
};

DashboardVideoBlock.propTypes = {
  block: PropTypes.shape({
    resource_uri: PropTypes.string.isRequired,
  }).isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardVideoBlock);
